import React from "react";

import reasonLogo from "../../images/reason-logo-white.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="page-footer">
      <div className="row">
        <div className="col s6 footer-top-padding text-center">
          <a
            className="grey-text text-lighten-4 paragraph-padding"
            target="_blank"
            href="https://cavsapp.com/terms/"
          >
            Terms and Conditions
          </a>
          <a
            className="grey-text text-lighten-4 paragraph-padding justify-links"
            target="_blank"
            href="https://cavsapp.com/privacy/"
          >
            Privacy Policy
          </a>
          <a
            className="grey-text text-lighten-4 paragraph-padding justify-links"
            target="_blank"
            href="https://cavsapp.com/cookie-policy/"
          >
            Cookie Policy
          </a>
        </div>
        <div className="col s6 text-center">
          <a
            className="img-responsive"
            href="https://reason.consulting/"
            target="_blank"
          >
            <img
              src={`/${reasonLogo}`}
              alt="ReasonConsulting-logo"
              className="reason-logo"
            />
          </a>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container text-center">
          Copyright &#169; Reason Consulting Corporation {currentYear} &nbsp; |
          &nbsp; All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
